import React from "react" ;
import { IonModal, IonContent, IonGrid, IonRow, IonCol, IonTextarea, IonButton } from '@ionic/react';

const SupportModal = (props) => {
    return (
        <>
            <IonModal isOpen={props.isOpen}>
                <IonContent className="ion-padding view-details-popup">
                    <div className="popup-header">
                        <IonGrid>
                            <p className="close-outline" onClick={() => props.setIsOpen(false)}>
                                X
                            </p>
                            <IonRow>
                                <IonCol size="7">
                                    <h1>Support</h1>
                                </IonCol>
                                <IonCol size="5">
                                    <p>support@rydesharing.com.sg</p>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </div>
                    <div className="order-summary view-details-popup">
                        <IonGrid>
                            <div className="top-grid">
                                <IonRow>
                                    <IonCol>
                                        <p></p>
                                        <input
                                          type="text"
                                          className="support-input"
                                          placeholder="Name "
                                        />
                                        <input
                                          type="text"
                                          className="support-input"
                                          placeholder="Email "
                                        />
                                        <input
                                          type="text"
                                          className="support-input"
                                          placeholder="Mobile "
                                        />
                                        <IonTextarea
                                          placeholder="Message"
                                        ></IonTextarea>
                                        <IonButton
                                          color="primary"
                                          horizontal="end"
                                          size="medium"
                                          mode="ios"
                                        >
                                          Submit Request
                                        </IonButton>
                                    </IonCol>
                                </IonRow>
                            </div>
                        </IonGrid>
                    </div>
                </IonContent>
            </IonModal>
        </>
    )
}

export default SupportModal ;

//isOpen
//setIsOpen